import { Pixall, PixallTransformers } from 'reaxl-analytics-handlers';

const isVDP = (dataLayer) => dataLayer?.page?.pageName === 'vdp' || dataLayer?.page?.pg === 'fyc_vdp';
const { inventoryTransformer } = PixallTransformers;

/**
 * @summary Sends Pixall Click event on Treehouse Ad CTA Click
 */
export async function treehouseAdCTAClick({ dataLayer, data = {} }, option) {
    const { inventory = {} } = data;

    const vehicle = inventoryTransformer.getInventoryData(inventory);
    vehicle.listingType = inventory?.listingType || 'lstg';

    Pixall.sendClickEvent({
        eventSource: 'personalization',
        eventType: 'click',
        label: 'cta::get-a-free-installation-estimate',
        cdl: {
            eventProperties: {
                element: 'Treehouse Estimate',
                elementText: 'Get A Free Installation Estimate',
                action: 'Click',
                tagIndex: isVDP(dataLayer) ? 'vdp-158' : 'srp-158',
            },
        },
        hasListingType: isVDP(dataLayer),
        ...(isVDP(dataLayer) ? vehicle : {}),
    }, dataLayer, option);

    return {};
}

/**
 * @summary Sends Pixall Impressions event on Treehouse Ad in view impression
 */
export function treehouseImpression({ dataLayer, data = {} }, option = {}) {
    const { inventory = {} } = data;

    const vehicle = inventoryTransformer.getInventoryData(inventory);
    vehicle.listingType = inventory?.listingType || 'lstg';

    Pixall.sendImpression({ dataLayer }, {
        eventSource: 'personalization',
        eventType: 'impression',
        label: 'Inline::Treehouse',
        program: 'fba',
        cdl: {
            eventProperties: {
                element: 'Inline Treehouse',
                action: 'Impression',
                tagIndex: isVDP(dataLayer) ? 'vdp-063' : 'srp-157',
            },
        },
        hasListingType: isVDP(dataLayer),
        ...(isVDP(dataLayer) ? vehicle : {}),
    }, option);

    return {};
}

export default {
    treehouseAdCTAClick,
    treehouseImpression,
};
